<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Accreditations')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("add") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <company-accreditations-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :companyId="company_id"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "AccreditationTable",
  mixins: [TableHelpers],
  data() {
    return {
      company_id: this.$attrs['props'].company_id,
      id:'',
      isViewModalActive: false,
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "accreditation-table",
      rowData: {},
      options: {
        url: actions.COMPANY_ACCREDITATION_LIST+'?company_id='+this.$attrs['props'].company_id,
        name: this.$t("accreditations"),
        datatableWrapper: false,
        showHeader: true,
        columns: [
          {
            title: "Certificate ID",
            type: "custom-html",
            key: "certificate_id",
            modifier: (value) => {
              return `<span>${value ?? '---'}</span>`;
            },
          },
          {
            title: "Certification Body",
            type: "custom-html",
            key: "certification_body",
            modifier: (value) => {
              return `<span>${value ?? '---'}</span>`;
            },
          },
          {
            title: "Certificate Name",
            type: "custom-html",
            key: "certificate_name",
            modifier: (value) => {
              return `<span>${value ?? '---'}</span>`;
            },
          },
          {
            title: "Date Achieved",
            type: "custom-html",
            key: "date_achieved",
            modifier: (value) => {
              // Assuming "date_achieved" is a date field, format it as needed
              return `<span>${value ? new Date(value).toLocaleDateString() : '---'}</span>`;
            },
          },
          {
            title: "Expiry Date",
            type: "custom-html",
            key: "expiry_date",
            modifier: (value) => {
              // Assuming "expiry_date" is a date field, format it as needed
              return `<span>${value ? new Date(value).toLocaleDateString() : '---'}</span>`;
            },
          },
          {
            title: this.$t("attachment"),
            type: "custom-html",
            key: "certificate_file",
            modifier: (value) => {
              let content = '---';
              if (value) {
                content = `<a href="${value}" download>Download Attachment</a>`
              }
              return `<span>${content}</span>`;
            },
          },
          {
            title: "Status",
            type: "custom-html",
            key: "status",
            modifier: (value) => {
              return `<span>${value ?? '---'}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "accreditation-delete",
          // },
        ],
        showFilter: false,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 20,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#accreditation-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    openViewModal() {
      this.isViewModalActive = true;
    },
    closeViewModal() {
      $("#demo-view-Modal").modal("hide");
      this.isViewModalActive = false;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.COMPANY_ACCREDITATION_EDIT}/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.CERTIFICATE_CATEGORY_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
};
</script>
